import { render, staticRenderFns } from "./communityIssueCPerson.vue?vue&type=template&id=62d7fdc6&scoped=true&lang=pug&"
import script from "./communityIssueCPerson.vue?vue&type=script&lang=js&"
export * from "./communityIssueCPerson.vue?vue&type=script&lang=js&"
import style0 from "./communityIssueCPerson.vue?vue&type=style&index=0&id=62d7fdc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7fdc6",
  null
  
)

export default component.exports